import React from "react";
import { Stack } from "@bookingcom/bui-react";
export function FlightTimelineContentUI(props) {
    const { content, ...rest } = props;
    return (React.createElement(Stack, { ...rest, grow: true },
        React.createElement(Stack.Item, { grow: true }, content)));
}
